import { render, staticRenderFns } from "./ProtoMap.vue?vue&type=template&id=5e328b15&scoped=true&"
import script from "./ProtoMap.vue?vue&type=script&lang=js&"
export * from "./ProtoMap.vue?vue&type=script&lang=js&"
import style0 from "./ProtoMap.vue?vue&type=style&index=0&id=5e328b15&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e328b15",
  null
  
)

export default component.exports